import { VStack } from '@cbhq/cds-web/layout';
import { memo } from 'react';
import { PoolDetailsData } from '../hooks/usePoolDetailsData';
import EarnCard from './EarnCard';
import StatsCard from './StatsCard';
import RewardsCard from './RewardsCard';

type Props = {
  pool: PoolDetailsData;
};

export const PoolDetailsSidebar = memo(function PoolDetailsSidebar({ pool }: Props) {
  return (
    <VStack gap={2}>
      <EarnCard totalApr={pool.totalApr} tradingFee={pool.tradingFee} />
      <StatsCard
        tvl={pool.tvl}
        tvlChange={pool.tvlChange}
        volume24h={pool.volume24h}
        volume24hChange={pool.volume24hChange}
        fees24h={pool.fees24h}
        fees24hChange={pool.fees24hChange}
      />
      <RewardsCard hasUsdcRewards={pool.hasUsdcRewards} rewardRate={pool.rewardRate} />
    </VStack>
  );
});
